// extracted by mini-css-extract-plugin
export default {"Registration-Header":"Headers_Registration-Header__vW-nv","Heading":"Headers_Heading__q6t+a","SubHeading":"Headers_SubHeading__C2rx7","Children":"Headers_Children__vygfm"};